// Public surface of the ARIA module. Code outside `aria` imports from here.
//
// Together with `packages/forge-shell-contract/aria`, this file is the whole
// interface between ARIA and the rest of the app. The list is still longer
// than it should be: it reflects what outside code reached into the old
// component directories for, not a designed API. Add an entry only when a
// caller outside `aria` needs it, and prefer removing entries over adding
// them. `externalBindings/` is not re-exported here; pages import those files
// directly, and the mount sites render `AriaEntrypoint.tsx` (see AGENTS.md).
export type {AgentChatEntryPoint, WBAgentController} from './chat/controller';
export {useWBAgentController} from './chat/controller';
export {AriaControllerRegistration} from './chat/controller/AriaControllerRegistration';
export {NonLocalAriaController} from './chat/controller/NonLocalAriaController';
export {
  AgentPageContextGroup,
  AgentPageContextLayer,
  LARGE_PROJECT_RUN_VISIBILITY_NOTE,
} from './chat/pageContext';
export type {WandbWorkspacePanelPart} from './chat/store/thread';
export {useAgentChatReadonly} from './chat/useAgentChatReadonly';
export type {
  AnyPromptPart,
  HttpUserPrompt,
  PromptTextPart,
  PromptWandbArtifactCollectionPart,
} from './client/promptParts';
export {isKnownPromptPart} from './client/promptParts';
export type {TurnSSEFrame} from './client/streamEvents';
export {useWbAgentClient} from './client/useWbAgentClient';
export type {TurnResponse, WbAgentClient} from './client/WbAgentClient';
export {AGENT_NAME, MAIN_CONTENT_WIDTH_CSS} from './components/constants';
export type {WBAgentCallKind} from './components/suggestions/catalog';
export {
  callReferenceLabels,
  callReferencePlaceholder,
  entryPointPlaceholders,
  entryPointPrompts,
} from './components/suggestions/catalog';
export {useComputeAgentChatAvailability} from './components/useAgentChatAvailability';
export {useTrackWBAgentComposer} from './components/useTrackWBAgent';
export {
  WBAgentEntryPointButton,
  WBAgentEntryPointIconButton,
  WBAgentEntryPointTooltip,
} from './components/WBAgentEntryPointButton';
